<template>
  <div class="own-reports">
    <div class="own-reports-header">
      <h2 v-if="!reports.length">Моите отчети</h2>
      <h2 v-else>Моите последно направени отчети</h2>
      <div class="btns">
        <button class="btn btn-new" @click="newReport()">
          <span class="sienit">H</span>
          Нов отчет
        </button>
        <button
          class="btn btn-excel"
          v-if="reports.length"
          @click="exportFile()"
        >
          <span class="sienit">E</span>
          Експорт в Excel
        </button>
      </div>
    </div>
    <div class="reports-wrapper">
      <p v-if="!reports.length" class="no-reports">Нямате направени отчети</p>

      <div v-else class="reports-list mobile">
        <button
          v-for="r in searchFilter()"
          :key="`mobile-report-${r._id}`"
          class="report-mobile-row"
          :class="{ 'report-mobile-row--invalid': r.isInvalid }"
          type="button"
          @click="viewReport(r._id)"
        >
          <span class="report-mobile-row__icons">
            <span class="report-mobile-row__icon sienit2">B</span>
            <span
              class="report-creation-method"
              :title="creationMethodMeta(r).label"
            >
              <img
                v-if="creationMethodMeta(r).icon"
                :src="creationMethodMeta(r).icon"
                alt=""
              />
              <span v-else>{{ creationMethodMeta(r).letter }}</span>
            </span>
          </span>
          <span class="report-mobile-row__body">
            <span class="report-mobile-row__heading">
              <strong>{{ r.date | formatDate }}</strong>
              <span v-if="r.isInvalid" class="report-mobile-row__invalid">
                Грешен отчет
              </span>
            </span>
            <span class="report-mobile-row__location">
              {{ reportLocation(r) }}
            </span>
            <span class="report-mobile-row__counts">
              <span>
                <strong>{{ diaryCount(r, "materials") }}</strong>
                отчетени
              </span>
            </span>
            <span class="report-mobile-row__items">
              {{ reportedItems(r) }}
            </span>
          </span>
          <span
            v-if="showPriceStatus"
            class="report-mobile-row__price-status"
            :class="`report-mobile-row__price-status--${r.priceStatus}`"
            :title="priceStatusText(r.priceStatus)"
          ></span>
          <span class="report-mobile-row__arrow sienit">M</span>
        </button>
      </div>

      <div v-if="reports.length" class="table-wrapper desktop">
        <table class="table" ref="table">
          <thead>
            <tr>
              <th>Дата</th>
              <th>Проект</th>
              <th>Обект</th>
              <th>Подобект</th>
              <th>Част</th>
              <!-- <th class="center">Отчетени хора</th>
            <th class="center">Общо отчетено време</th>-->
              <th class="center">Отчетено</th>
              <th>Списък отчетено</th>
              <th v-if="showPriceStatus" class="price-status-cell"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="r in searchFilter()"
              :key="`findReport-${r._id}`"
              @click="viewReport(r._id)"
              :class="{ 'tr-invalid': r.isInvalid }"
            >
              <td>
                <span class="report-date-cell">
                  <span
                    class="report-creation-method"
                    :title="creationMethodMeta(r).label"
                  >
                    <img
                      v-if="creationMethodMeta(r).icon"
                      :src="creationMethodMeta(r).icon"
                      alt=""
                    />
                    <span v-else>{{ creationMethodMeta(r).letter }}</span>
                  </span>
                  <span class="no-wrap">{{ r.date | formatDate }} г.</span>
                </span>
              </td>
              <td class="td-company-name">
                <img
                  class="td-invalid-flag"
                  v-if="r.isInvalid"
                  src="../assets/img/flag_yes.svg"
                  alt="invalid"
                />
                {{ r.company.companyName }}
              </td>
              <td>{{ r.project.projectName }}</td>
              <td>{{ r.object.objectName }}</td>
              <td>
                <span v-if="r.part">{{ r.part.partName }}</span>
              </td>
              <td class="center">{{ diaryCount(r, "materials") }}</td>
              <td>{{ reportedItems(r) }}</td>
              <td v-if="showPriceStatus" class="price-status-cell">
                <img
                  class="flag-indicator"
                  v-if="r.priceStatus === 2"
                  src="../assets/img/green.svg"
                  alt="Всички цени са въведени"
                  title="Всички цени са въведени"
                />
                <img
                  class="flag-indicator"
                  v-else-if="r.priceStatus === 1"
                  src="../assets/img/yellow.svg"
                  alt="Има невъведени цени"
                  title="Има невъведени цени"
                />
                <img
                  class="flag-indicator"
                  v-else-if="r.priceStatus === 0"
                  src="../assets/img/red.svg"
                  alt="Няма въведени цени"
                  title="Няма въведени цени"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- BUTTONS FOR MOBILE -->
    <footer class="modal-footer mobile">
      <div
        class="new-content-data-item-toggle-circle mobile excel"
        v-if="this.reports.length"
        @click="exportFile()"
      >
        <span class="sienit">E</span>
      </div>
      <div
        class="new-content-data-item-toggle-circle mobile"
        @click="newReport()"
      >
        <span class="sienit">L</span>
      </div>
    </footer>
    <Pagination :total="total" :size="size" />
  </div>
</template>

<script>
import hours from "./mixins/hours.js";
import { mapGetters } from "vuex";
import XLSX from "xlsx";
import Pagination from "../components/shared/Pagination.vue";

const creationMethodMetadata = {
  manual: {
    label: "Създаден ръчно",
    letter: "Р",
  },
  voice: {
    label: "Създаден с глас",
    icon: require("../assets/img/report/auto-report-microphone.svg"),
  },
  image: {
    label: "Създаден от снимка",
    icon: require("../assets/img/report/auto-report-camera.svg"),
  },
  text: {
    label: "Създаден от текст",
    letter: "T",
  },
  mixed: {
    label: "Създаден с няколко метода",
    letter: "M",
  },
};

export default {
  mixins: [hours],
  components: {
    Pagination,
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      "getUser",
      // ...
    ]),
    showPriceStatus() {
      const permissions = this.getUser && this.getUser.permissions;
      return Boolean(
        permissions && (permissions.isSuperAdmin || permissions.isAdmin)
      );
    },
  },
  data() {
    return {
      reports: [],
      search: "",
      total: 0,
      size: 30,
    };
  },
  watch: {
    $route: {
      handler: "getReports",
      immediate: true,
    },
  },
  methods: {
    // Filter reports by date, companyName, projectName or objectName
    searchFilter() {
      return this.reports.filter((r) => {
        return (
          r.date.toLowerCase().includes(this.search.toLowerCase()) ||
          r.company.companyName
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
          r.project.projectName
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
          r.object.objectName.toLowerCase().includes(this.search.toLowerCase())
          // || r.part.partName.toLowerCase().includes(this.search.toLowerCase())
        );
      });
    },
    viewReport(id) {
      this.$router.push(`/reports/edit/${id}`);
    },
    creationMethodMeta(report) {
      return (
        creationMethodMetadata[report.creationMethod] ||
        creationMethodMetadata.manual
      );
    },
    reportLocation(report) {
      return [
        report.company && report.company.companyName,
        report.project && report.project.projectName,
        report.object && report.object.objectName,
        report.part && report.part.partName,
      ]
        .filter(Boolean)
        .join(" / ");
    },
    priceStatusText(status) {
      if (status === 2) return "Всички цени са въведени";
      if (status === 1) return "Има невъведени цени";
      return "Няма въведени цени";
    },
    diaryRows(report, sectionKey) {
      return report.diary && Array.isArray(report.diary[sectionKey])
        ? report.diary[sectionKey]
        : [];
    },
    diaryCount(report, type) {
      if (type === "materials") {
        return this.diaryRows(report, "buildingMaterials").length;
        // this.diaryRows(report, "movedInventory").length +
        // this.diaryRows(report, "receivedInventory").length
      }

      if (type === "activities") {
        return this.diaryRows(report, "consumedWithoutFinalResult").length;
      }

      if (type === "mechanizations") {
        return this.diaryRows(report, "mechanizations").length;
      }

      return 0;
    },
    reportedItems(report) {
      return this.diaryRows(report, "buildingMaterials")
        .map((row) => row.name)
        .filter(Boolean)
        .join(", ");
    },
    toNumber(value) {
      const number = Number(value);
      return Number.isFinite(number) ? number : 0;
    },
    diaryPricingRows(report) {
      return [
        ...this.diaryRows(report, "buildingMaterials").map((row) => ({
          price: row.price,
          quantity: row.incomingQuantity,
        })),
        ...this.diaryRows(report, "movedInventory").map((row) => ({
          price: row.price,
          quantity: row.quantity,
        })),
        ...this.diaryRows(report, "consumedWithoutFinalResult").map((row) => ({
          price: row.price,
          quantity: row.dailyCompletion,
        })),
        ...this.diaryRows(report, "receivedInventory").map((row) => ({
          price: row.price,
          quantity: row.quantity,
        })),
      ];
    },
    getStatuses() {
      if (this.reports.length) {
        this.reports.forEach((r) => {
          let status = 2;
          let total = 0;

          this.diaryPricingRows(r).forEach((row) => {
            total += this.toNumber(row.price) * this.toNumber(row.quantity);
            if (!this.toNumber(row.price)) {
              status = 1;
            }
          });

          if (!total) {
            status = 0;
          }

          r.priceStatus = status;
        });
      }
    },
    getReports() {
      this.$store.dispatch("startLoading");
      let id = this.getUser._id;
      let url = `${process.env.VUE_APP_BASE_URI}/report/myreports/${id}?size=${
        this.size
      }&page=${this.$route.query.page || 1}`;
      this.$http
        .get(url)
        .then((response) => {
          this.reports = response.data.reports;
          this.total = response.data.total;

          this.$store.dispatch("stopLoading");
          if (this.showPriceStatus) {
            this.getStatuses();
          }
        })
        .catch((error) => console.log(error));
    },
    newReport() {
      this.$router.push("/reports/new");
    },
    // Export To Excel
    exportFile() {
      let worksheet = XLSX.utils.table_to_sheet(this.$refs.table);
      let new_workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(new_workbook, worksheet, `Reports`);
      XLSX.writeFile(new_workbook, `report-${Date.now()}.xlsx`);
    },
  },
  updated() {
    // Handle search input
    this.$root.$on("sendSearchInput", (data) => {
      this.search = data;
      // console.log(this.search);
    });
  },
  destroyed() {
    this.$root.$off("sendSearchInput");
  },
};
</script>

<style scoped lang="scss">
.own-reports {
  min-height: calc(100vh - 130px);
  padding: 10px 40px;
}

.own-reports-header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;

  h2 {
    color: var(--color-text);
  }
}

.table-wrapper {
  overflow: auto;
}

.desktop {
  display: flex;
}

.mobile {
  display: none;
}

.no-reports {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  color: var(--color-text-muted);
  font-size: 18px;
  padding: 20px;
  text-align: center;
}

tr td.price-status-cell {
  width: 1%;
}

.report-date-cell {
  align-items: center;
  display: inline-flex;
  gap: 8px;
}

.report-creation-method {
  align-items: center;
  background: #000;
  border-radius: 50%;
  color: #fff;
  display: inline-flex;
  flex: 0 0 24px;
  font-size: 12px;
  font-weight: 700;
  height: 24px;
  justify-content: center;
  line-height: 1;
  width: 24px;

  img {
    filter: invert(1);
    height: 13px;
    width: 13px;
  }
}

/* Responsive */
@media screen and (max-width: 1000px) {
  .desktop {
    display: none;
  }

  .mobile {
    display: flex;
  }
  .table-wrapper {
    background: var(--color-surface);
    border: 1px solid var(--color-border);
    border-radius: 6px;
  }

  .reports-list {
    display: flex;
    flex-direction: column;
    gap: calc(var(--gap) + var(--gap));
    max-width: 100%;
  }

  .report-mobile-row {
    align-items: center;
    background: var(--color-surface);
    border: 1px solid var(--color-border);
    border-radius: 16px;
    color: var(--color-text);
    cursor: pointer;
    display: grid;
    font: inherit;
    gap: calc(var(--gap) + var(--gap));
    grid-template-columns: 42px minmax(0, 1fr) auto auto;
    height: auto;
    min-height: 84px;
    padding: 10px 12px;
    text-align: left;
    transition: var(--transition);
    width: 100%;

    &:hover,
    &:focus-visible {
      background: var(--color-surface-hover);
      border-color: var(--color-border-strong);
      outline: none;
      transform: translateY(-1px);
    }
  }

  .report-mobile-row--invalid {
    background: var(--color-danger-medium);
    border-color: var(--color-danger-border);

    &:hover,
    &:focus-visible {
      background: var(--color-danger-medium);
      border-color: var(--color-danger);
    }
  }

  .report-mobile-row__icon {
    align-items: center;
    background: var(--color-main);
    border-radius: 50%;
    color: var(--color-on-main);
    display: inline-flex;
    font-size: 21px;
    height: 42px;
    justify-content: center;
    width: 42px;
  }

  .report-mobile-row__icons {
    align-items: center;
    align-self: stretch;
    display: flex;
    flex-direction: column;
    gap: 6px;
    justify-content: center;
  }

  .report-mobile-row__icons .report-creation-method {
    flex-basis: 24px;
  }

  .report-mobile-row__body {
    display: grid;
    gap: var(--gap);
    min-width: 0;
  }

  .report-mobile-row__heading {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: calc(var(--gap) + 2px);

    strong {
      color: var(--color-text);
      font-size: 19px;
      line-height: 1.1;
    }
  }

  .report-mobile-row__invalid {
    background: var(--color-danger);
    border-radius: 10px;
    color: var(--color-on-main);
    font-size: 9px;
    font-weight: 700;
    padding: 3px 7px;
    text-transform: uppercase;
  }

  .report-mobile-row__location {
    color: var(--color-text-muted);
    font-size: 14px;
    line-height: 1.25;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .report-mobile-row__counts {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 12px;

    span {
      color: var(--color-text-subtle);
      font-size: 11px;
      white-space: nowrap;
    }

    strong {
      color: var(--color-main);
      font-size: 12px;
    }
  }

  .report-mobile-row__items {
    color: var(--color-text-subtle);
    font-size: 11px;
    line-height: 1.3;
  }

  .report-mobile-row__price-status {
    border: 2px solid var(--color-on-main);
    border-radius: 50%;
    box-shadow: 0 0 0 1px var(--color-border);
    height: 12px;
    width: 12px;
  }

  .report-mobile-row__price-status--2 {
    background: var(--color-success);
  }

  .report-mobile-row__price-status--1 {
    background: var(--color-warning);
  }

  .report-mobile-row__price-status--0 {
    background: var(--color-danger);
  }

  .report-mobile-row__arrow {
    color: var(--color-main);
    font-size: 14px;
  }

  .own-reports {
    min-height: calc(100vh - 110px);
    padding: 12px 15px 90px;
  }

  .own-reports-header {
    margin-bottom: 12px;

    h2 {
      font-size: 18px;
      margin: 0;
    }

    .btns {
      display: none;
    }
  }

  .btns.mobile {
    display: flex;
    float: left;
    flex-direction: column-reverse;
    justify-items: flex-end;
    position: fixed;
  }

  .new-content-data-item-toggle-circle {
    box-shadow: 0 3px 10px rgba(41, 16, 3, 0.22);
    width: 50px;
    height: 50px;
  }

  .new-content-data-item-toggle-circle.mobile {
    bottom: 20px;
    cursor: pointer;
    position: fixed;
    right: 20px;
  }
  .new-content-data-item-toggle-circle.mobile.excel {
    background-color: #217346;
    bottom: 75px;
    cursor: pointer;
    right: 20px;
    position: fixed;
  }
  .new-content-data-item-toggle-circle .sienit {
    border: 0px;
    font-size: 20px;
  }
  .modal-footer {
    background: transparent;
    height: 0;
    padding: 0;
  }
}

@media screen and (max-width: 520px) {
  .report-mobile-row {
    border-radius: 14px;
    gap: calc(var(--gap) + 3px);
    grid-template-columns: 38px minmax(0, 1fr) auto auto;
    min-height: 78px;
    padding: 9px 10px;
  }

  .report-mobile-row__icon {
    font-size: 19px;
    height: 38px;
    width: 38px;
  }

  .report-mobile-row__heading strong {
    font-size: 17px;
  }

  .report-mobile-row__location {
    font-size: 13px;
  }

  .report-mobile-row__counts {
    gap: 3px 8px;

    span {
      font-size: 10px;
    }
  }
}
</style>
